/** "client" backend async checkers unique keys */
export enum ClientCheckerKeysEnum {
  /** Checks that bank details exists and not deleted (version for identifiers) */
  BANK_DETAILS_ASSERT_EXISTS_BY_ID = 'client/bank-details-assert-exists-by-id',
  /** Checks that bank details exists and not deleted (version for DTOs with identifiers) */
  BANK_DETAILS_ASSERT_EXISTS_BY_DTO = 'client/bank-details-assert-exists-by-dto',
  /** Checks that client exists and not deleted (version for identifiers) */
  CLIENT_ASSERT_EXISTS_BY_ID = 'client/client-assert-exists-by-id',
  /** Checks that client exists and not deleted (version for DTOs with identifiers) */
  CLIENT_ASSERT_EXISTS_BY_DTO = 'client/client-assert-exists-by-dto',
  /** Checks that company or companies exists and not deleted (version for identifiers) */
  COMPANY_ASSERT_EXISTS_BY_ID = 'client/company-assert-exists-by-id',
  /** Checks that company or companies exists and not deleted (version for DTOs with identifiers) */
  COMPANY_ASSERT_EXISTS_BY_DTO = 'client/company-assert-exists-by-dto',
  /** Checks that counterparty or counterparties exists and not deleted (version for identifiers) */
  CONTRAGENT_ASSERT_EXISTS_BY_ID = 'client/contragent-assert-exists-by-id',
  /** Checks that counterparty or counterparties exists and not deleted (version for DTOs with identifiers) */
  CONTRAGENT_ASSERT_EXISTS_BY_DTO = 'client/contragent-assert-exists-by-dto',
}
